import React from 'react';
import { Tabs, Tab } from 'react-bootstrap';
import PropTypes from 'prop-types';

const CustomTab = ({ tabs, onSelect, customClass, defaultActiveKey }) => {
  return (
    <Tabs className={customClass} fill defaultActiveKey={defaultActiveKey} onSelect={onSelect}>
      {tabs.map((tab) => (
        <Tab eventKey={tab.id} title={tab.title} key={tab.id}>
          {tab.renderContent()}
        </Tab>
      ))}
    </Tabs>
  );
};

CustomTab.propTypes = {
  tabs: PropTypes.array.isRequired,
  onSelect: PropTypes.func.isRequired,
  customClass: PropTypes.string,
  defaultActiveKey: PropTypes.any
};

export default CustomTab;
